import { FORM_NAME } from '../data/constants';
import { FormBuilder, FormShape, PremiumReportFormTransformer } from '../types';

const getPremiumReportForm = (
	props: PremiumReportFormTransformer,
	name = FORM_NAME.PREMIUM_REPORT_FORM as keyof FormShape<FormBuilder>,
) => {
	const { fields, premiumReport } = props;
	const { fieldGroupsByLocator, fieldValues } = premiumReport;

	return {
		[name]: {
			fields,
			fieldGroupsByLocator,
			mediaByLocator: {},
			externalDataCalls: {},
			values: fieldValues,
		} as FormBuilder,
	} as FormShape<FormBuilder>;
};

export default getPremiumReportForm;
